// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"366a9900","239":"579a9a67","455":"74d2089d"}[chunkId] + ".chunk.js";
};